(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('usersController', usersController)
        .controller('newUserController', newUserController)
        .controller('editUserController', editUserController)
        .controller('deleteUserController', deleteUserController)
        .controller('modalApplyUserRoleCtrl', modalApplyUserRoleCtrl)
        .controller('associatedBranchOfficeCtrl', associatedBranchOfficeCtrl);

    usersController.$inject = ['users', 'linkService'];
    newUserController.$inject = ['$uibModal', 'branchOffices', 'linkService', 'userService', 'clientService','positionTypes', 'CONFIG'];
    editUserController.$inject = ['$uibModal', 'linkService', 'userService', 'clientService', 'userId', 'user',
        'branchOffices','positionTypes', 'CONFIG'];
    deleteUserController.$inject = ['userId', 'user', 'userService', '$uibModalInstance'];
    modalApplyUserRoleCtrl.$inject = ['$uibModalInstance', 'linkService', 'roleService', 'clients','userRoles'];
    associatedBranchOfficeCtrl.$inject = ['$uibModal','linkService', 'branchOffices','user','userService'];

    function usersController(users, linkService){
        var vm = this;
        vm.pages = [];
        vm.linkService = linkService;
        vm.users = (users.data._embedded) ? users.data._embedded.users : [];
        vm.pages = users.data.page;
        vm.links = users.data._links;
    }

    function newUserController($uibModal, branchOffices, linkService, userService, clientService, positionTypes, CONFIG){
        var vm = this;
        vm.branchOffices = (branchOffices.data._embedded) ? branchOffices.data._embedded.branchOffices : [];
        vm.positionTypes = getPositionTypes(positionTypes);
        vm.user = {
            userRoles: []
        };

        vm.saveUser = function(isValid, user){
            if(isValid){
                var saveData = {
                    "roles": rolesUser(user.userRoles, linkService),
                    "user": {
                        "name": user.name,
                        "lastName": user.lastName,
                        "login": user.email + '@' + CONFIG.DOMAIN_ID,
                        "email": user.email,
                        "branchOfficeId": parseInt(linkService.getLinkId(user.branchOffice._links.self.href)),
                        "positionType": user.positionType.code,
                        "domainId": CONFIG.DOMAIN_ID
                    }
                };
                userService.saveUser(saveData)
            }
        }

        vm.addLogin =  function(){
            if(vm.user){
                vm.user.login= vm.user.email;
            }
        }

        vm.addUserRoles = function(){
            $uibModal.open({
                templateUrl: 'app/admin/configGeneral/user/modalApplyUserRole.html',
                controller: 'modalApplyUserRoleCtrl',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    clients: ['clientService', function(clientService){
                        return clientService.getAllApplicationUiTrue();
                    }],
                    userRoles: [function(){
                        return vm.user.userRoles;
                    }]
                }
            }).result.then(function(response) {
                vm.user.userRoles.push(response.userRole.role);
            }, function() {
                //$state.go('^');
            });
        }

        vm.deleteUserRoles = function(index){
            vm.user.userRoles.splice(index, 1)
        }
    }

    function editUserController($uibModal, linkService, userService, clientService, userId, user, branchOffices, positionTypes, CONFIG){
        var vm = this;
        vm.linkService = linkService;
        vm.user = user.data;
        vm.user.branchOffice = user.data._embedded.branchOffice;
        vm.user.userRoles = user.data._embedded.roles;
        vm.user.positionType = getPositionType(user.data.positionType);
        vm.branchOffices = (branchOffices.data._embedded) ? branchOffices.data._embedded.branchOffices : [];
        vm.positionTypes = getPositionTypes(positionTypes);
        vm.loginSplit = (user.data.login).split('@');
        vm.user.login = vm.loginSplit[0] + '@' + vm.loginSplit[1];
        vm.old = angular.copy(vm.user);
        vm.buttonSave = true;

        vm.saveUser = function(isValid, user){
            if (isValid) {
                var saveData = {
                    "roles": rolesUser(user.userRoles, linkService),
                    "user": {
                        "name": user.name,
                        "lastName": user.lastName,
                        "login": user.email + '@' + CONFIG.DOMAIN_ID,
                        "email": user.email,
                        "branchOfficeId": parseInt(linkService.getLinkId(user.branchOffice._links.self.href)),
                        "positionType": user.positionType.code,
                        "domainId": CONFIG.DOMAIN_ID
                    }
                }
                userService.updateUser(saveData, userId);
            }
        }

        vm.addUserRoles = function(){
            $uibModal.open({
                templateUrl: 'app/admin/configGeneral/user/modalApplyUserRole.html',
                controller: 'modalApplyUserRoleCtrl',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    clients: ['clientService', function(clientService){
                        return clientService.getAllApplicationUiTrue();
                    }],
                    userRoles: [function(){
                        return vm.user.userRoles;
                    }]
                }
            }).result.then(function(response) {
                vm.user.userRoles.push(response.userRole.role);
                vm.change();
            }, function() {
                //$state.go('^');
            });
        }

        vm.deleteUserRoles = function(index){
            vm.user.userRoles.splice(index, 1)
        }

        vm.change = function(){
            if(vm.user.branchOffice != undefined && vm.user.branchOffice.name == vm.old.branchOffice.name &&
                vm.user.name.toUpperCase() == vm.old.name.toUpperCase() &&
                vm.user.lastName.toUpperCase() == vm.old.lastName.toUpperCase() &&
                vm.user.email == vm.old.email && vm.user.userRoles.length == vm.old.userRoles.length &&
                vm.user.positionType != undefined && vm.user.positionType.code == vm.old.positionType.code){
                for(var i=0; i<vm.user.userRoles.length; i++){
                    var flag = false;
                    for(var j=0; j<vm.old.userRoles.length; j++){
                        if(vm.user.userRoles[i].name == vm.old.userRoles[j].name){
                            flag = true;
                            break;
                        }
                    }
                    if(!flag){
                        vm.buttonSave = false;
                        break;
                    }
                }
                if(flag){
                    vm.buttonSave=true;
                }
            }else{
                vm.buttonSave = false;
            }
        }
    }

    function deleteUserController(userId, user, userService, $uibModalInstance){
        var vm = this;
        vm.name = user.data.name + " " + user.data.lastName;

        vm.deleteUser = function(){
            userService.deleteUser(userId)
                .then(function(){
                    $uibModalInstance.close(true);
                });
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function rolesUser(userRoles, linkService){
        var res = [];
        angular.forEach(userRoles, function(userRole){
            res.push(parseInt(linkService.getLinkId(userRole._links.self.href)))
        });
        return res;
    }

    function modalApplyUserRoleCtrl($uibModalInstance, linkService, roleService, clients, userRoles){
        var vm = this;
        vm.linkService = linkService;
        vm.clients = clients.data?clients.data:[];
        vm.clients = getClients();
        //vm.grantTypesCheckBox = getSelectCheckBox(vm.grantTypes, stringGrantTypes);

        vm.getRoles = function(name){
            roleService.getRoleByClient(name)
                .then(function(response){
                    vm.roles = (response.data._embedded) ? response.data._embedded.roles : [];
                });
        }

        vm.addRole = function(isValid, userRole){
            if(isValid){
                $uibModalInstance.close({userRole: userRole});
            }
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function getClients(){
            var clients= [];
            angular.forEach(vm.clients, function(client) {
                if(!thereIsClient(client.client, userRoles)) {
                    clients.push(client)
                }
            });
            return clients;
        }

        function thereIsClient(client, userRoles) {
            var flag = false;
            angular.forEach(userRoles, function(userRole){
                if(client == userRole.clientId){
                    flag = true;
                }
            });
            return flag;
        }

    }

    function associatedBranchOfficeCtrl($uibModal, linkService, branchOffices, user, userService){
        var vm = this;
        vm.linkService = linkService;
        vm.branchOffices = (branchOffices.data._embedded) ? branchOffices.data._embedded.branchOffices : [];
        vm.user = user.data;
        vm.branchOfficesPredefined = 0;

        vm.selectCheckBoxAll = {};
        vm.selectCheckBox= {};

        vm.selectCheckBox = getSelectCheckBox(vm.user._embedded.branchOffices, vm.selectCheckBox, linkService);

        function getSelectCheckBox(branchOfficeUsers, selectCheckBox, linkService){
            angular.forEach(branchOfficeUsers, function (branchOfficeUser) {
                selectCheckBox[parseInt(linkService.getLinkId(branchOfficeUser._links.self.href))] = true;
                if(parseInt(linkService.getLinkId(branchOfficeUser._links.self.href))==parseInt(linkService.getLinkId(vm.user._embedded.branchOffice._links.self.href))){
                    vm.branchOfficesPredefined = parseInt(linkService.getLinkId(branchOfficeUser._links.self.href));
                }
            });
            return selectCheckBox;
        }

        vm.handleCheckBoxBOAll = function () {
            if (vm.selectCheckBoxAll['0'] !== undefined && vm.selectCheckBoxAll['0']) {
                angular.forEach(vm.branchOffices, function (branchOffice) {
                    vm.selectCheckBox[parseInt(linkService.getLinkId(branchOffice._links.self.href))] = true;
                });
            } else {
                angular.forEach(vm.branchOffices, function (branchOffice) {
                    vm.selectCheckBox[parseInt(linkService.getLinkId(branchOffice._links.self.href))] = false;
                });
            }
            vm.selectCheckBox[vm.branchOfficesPredefined] = true;
        }

        vm.handleCheckBoxBO = function () {
            vm.handleCheckBox('selectCheckBox', 'selectCheckBoxAll', vm.branchOffices.length, vm);
            vm.selectCheckBox[vm.branchOfficesPredefined] = true;
        }

        vm.handleCheckBox = function (selectCheckBox, selectCheckBoxAll, checkBoxesLength, vm) {
            var contCheckBox = 0;
            var cont =  checkBoxesLength;
            angular.forEach(vm[selectCheckBox], function (index, value) {
                if (index === true){
                    contCheckBox++;
                }
            });

            if (contCheckBox === 0) {
                vm[selectCheckBoxAll] = {"0": false};
            } else if (contCheckBox > 0 && contCheckBox !== cont) {
                vm[selectCheckBoxAll] = {"0": false};
            } else if (contCheckBox === cont) {
                vm[selectCheckBoxAll] = {"0": true};
            }
        }

        vm.saveBranchOfficeUser = function(valid){
            var branchOfficeIds = [];
            if(valid){
                angular.forEach(vm.selectCheckBox, function (index, value) {
                    if (index==true){
                        branchOfficeIds.push(value);
                    }
                });

                var userAux = {
                    branchOffices: branchOfficeIds
                }
                userService.updateAssociatedBranchOffice(vm.linkService.getLinkId(vm.user._links.self.href), userAux);
            }

        }
    }

    function getPositionTypes(positionTypes){
        var res = [];
        angular.forEach(positionTypes, function(positionType){
            var positionTypeAux = {
                "code": positionType,
                "name": ""
            }
            if(positionType == "GENERAL_ADMIN"){
                positionTypeAux.name = 'air.user.positionType.generalAdmin'
            }else{
                if(positionType == "REGIONAL_ADMIN"){
                    positionTypeAux.name = 'air.user.positionType.regionalAdmin'
                }else{
                    positionTypeAux.name = 'air.user.positionType.counter'
                }
            }
            res.push(positionTypeAux)
        });
        return res;
    }

    function getPositionType(positionType){
        var positionTypeAux = {
            "code": positionType,
            "name": ""
        }
        if(positionType == "GENERAL_ADMIN"){
            positionTypeAux.name = 'air.user.positionType.generalAdmin'
        }else{
            if(positionType == "REGIONAL_ADMIN"){
                positionTypeAux.name = 'air.user.positionType.regionalAdmin'
            }else{
                positionTypeAux.name = 'air.user.positionType.counter'
            }
        }
        return positionTypeAux;
    }
})();
